import DGS_000A from "../video/DGS_000A.mp4";
import DGS_000B from "../video/DGS_000B.mp4";
import DGS_001 from "../video/DGS_001.mp4";
import DGS_002 from "../video/DGS_002.mp4";
import DGS_003 from "../video/DGS_003.mp4";
import DGS_004 from "../video/DGS_004.mp4";
import DGS_005 from "../video/DGS_005.mp4";
import DGS_006 from "../video/DGS_006.mp4";
import DGS_007 from "../video/DGS_007.mp4";
import DGS_008 from "../video/DGS_008.mp4";
import DGS_009 from "../video/DGS_009.mp4";
import DGS_010 from "../video/DGS_010.mp4";
import DGS_011 from "../video/DGS_011.mp4";
import DGS_012A from "../video/DGS_012A.mp4";
import DGS_012B from "../video/DGS_012B.mp4";
import DGS_013A from "../video/DGS_013A.mp4";
import DGS_013B from "../video/DGS_013B.mp4";
import DGS_014A from "../video/DGS_014A.mp4";
import DGS_014B from "../video/DGS_014B.mp4";
import DGS_014C from "../video/DGS_014C.mp4";
import DGS_015A from "../video/DGS_015A.mp4";
import DGS_015B from "../video/DGS_015B.mp4";
import DGS_015C from "../video/DGS_015C.mp4";
import DGS_016 from "../video/DGS_016.mp4";
import DGS_017 from "../video/DGS_017.mp4";
import DGS_018 from "../video/DGS_018.mp4";
import DGS_019 from "../video/DGS_019.mp4";
import DGS_020 from "../video/DGS_020.mp4";
import DGS_021 from "../video/DGS_021.mp4";
import DGS_022 from "../video/DGS_022.mp4";
import DGS_023 from "../video/DGS_023.mp4";
import DGS_024 from "../video/DGS_024.mp4";
import DGS_025 from "../video/DGS_025.mp4";
import DGS_026 from "../video/DGS_026.mp4";
import DGS_027 from "../video/DGS_027.mp4";
import DGS_028 from "../video/DGS_028.mp4";
import DGS_029 from "../video/DGS_029.mp4";
import DGS_030 from "../video/DGS_030.mp4";
import DGS_031 from "../video/DGS_031.mp4";
import DGS_032 from "../video/DGS_032.mp4";
import DGS_033 from "../video/DGS_033.mp4";
import DGS_034 from "../video/DGS_034.mp4";
import DGS_035 from "../video/DGS_035.mp4";
import DGS_036 from "../video/DGS_036.mp4";
import DGS_037 from "../video/DGS_037.mp4";
import DGS_038 from "../video/DGS_038.mp4";
import DGS_039 from "../video/DGS_039.mp4";
import DGS_040 from "../video/DGS_040.mp4";
import DGS_041 from "../video/DGS_041.mp4";
import DGS_042 from "../video/DGS_042.mp4";
import DGS_043 from "../video/DGS_043.mp4";
import DGS_044 from "../video/DGS_044.mp4";
import DGS_045 from "../video/DGS_045.mp4";
import DGS_046 from "../video/DGS_046.mp4";

const VIDEO_ARRAY = [
  DGS_000A,
  DGS_001,
  DGS_002,
  DGS_003,
  DGS_004,
  DGS_005,
  DGS_006,
  DGS_007,
  DGS_008,
  DGS_009,
  DGS_010,
  DGS_011,
  DGS_012A,
  DGS_012B,
  DGS_013A,
  DGS_013B,
  DGS_014A,
  DGS_014B,
  DGS_014C,
  DGS_015A,
  DGS_015B,
  DGS_015C,
  DGS_016,
  DGS_017,
  DGS_018,
  DGS_019,
  DGS_020,
  DGS_021,
  DGS_022,
  DGS_023,
  DGS_024,
  DGS_025,
  DGS_026,
  DGS_027,
  DGS_028,
  DGS_029,
  DGS_030,
  DGS_031,
  DGS_032,
  DGS_033,
  DGS_034,
  DGS_035,
  DGS_036,
  DGS_037,
  DGS_038,
  DGS_039,
  DGS_040,
  DGS_041,
  DGS_042,
  DGS_043,
  DGS_044,
  DGS_045,
  DGS_046,
  DGS_000B,
];

export default VIDEO_ARRAY;
